import store from "../store";
export function resetState() {
  store.commit("setSimulationID", null);
  store.commit("setCapitalValue", 130000);
  store.commit("setGenderValue", "Uomo");
  store.commit("setYearValue", "7");
  store.commit("setAgeValue", "31-40");
  store.commit("setAreaValue", []);
  store.commit("setExtraProtectionValue", []);
  store.commit("setScenarios", []);
}

export function checkScenarioDataIsInvalid() {
  return (
    store.state.ageValue === "" ||
    store.state.genderValue === "" ||
    store.state.yearValue === "" ||
    store.state.areaValue.length === 0 ||
    store.state.scenarios.length !== 4
  );
}
export function checkAreaDataIsInvalid() {
  return (
    store.state.ageValue === "" ||
    store.state.genderValue === "" ||
    store.state.yearValue === "" ||
    store.state.areaValue.length === 0
  );
}

export function checkBaseDataIsInvalid() {
  return (
    store.state.ageValue === "" ||
    store.state.genderValue === "" ||
    store.state.yearValue === ""
  );
}

export function getMinAge(range) {
  if (range === "18-30") {
    return 18;
  }
  if (range === "31-40") {
    return 31;
  }
  if (range === "41-65") {
    return 41;
  }
  if (range === "66-80") {
    return 66;
  }
  return 0;
}
